import { render, staticRenderFns } from "./ExternalText.vue?vue&type=template&id=7d129ce6&"
import script from "./ExternalText.vue?vue&type=script&lang=js&"
export * from "./ExternalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d129ce6')) {
      api.createRecord('7d129ce6', component.options)
    } else {
      api.reload('7d129ce6', component.options)
    }
    module.hot.accept("./ExternalText.vue?vue&type=template&id=7d129ce6&", function () {
      api.rerender('7d129ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/ExternalText.vue"
export default component.exports